import { axiosAPI } from '@/axios';
import _ from 'lodash';
import qs from 'qs';

const loadComments = (filter) => {
  const query = qs.stringify(_.defaults(filter), {
    addQueryPrefix: true,
    skipNulls: true,
  });
  if (query) {
    return axiosAPI.get(`/contact-us-form${query}`);
  }
  return axiosAPI.get('/contact-us-form');
};

const loadCommentCategory = () => {
  return axiosAPI.get('/taxonomies/contact-form-category/terms');
};

const loadCommentById = (id) => {
  return axiosAPI.get(`/contact-us-form/${id}`);
};

const loadSetting = () => {
  return axiosAPI.get('/settings');
};

const updateSetting = (newSetting) => {
  return axiosAPI.put('/settings/edit', newSetting);
};

export {
  loadComments,
  loadCommentById,
  loadCommentCategory,
  loadSetting,
  updateSetting,
};
